<app-form-input
	
	[label]=""
	[name]="radioButtonCtrlName"
    [value]="radioButtonValue"
	[parentForm]="parentForm"
	[disabled]="disabled"
	
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			value: oui,
			label: step1.getoui
		},
		{
			value: non,
			label: step1.getnon
		}
	]"
>
</app-form-input>



<!--<fieldset>
 <legend>
  TypeOuiNon
 </legend>
 <app-form-input 
[parentForm]="parentForm" 
[value]="variantes.oui" 
 
[label]="'oui'"
[type]="'tofix'"
[name]="getUid()+'_SepAtt_oui'">
</app-form-input>


<app-form-input 
[parentForm]="parentForm" 
[value]="variantes.non" 
 
[label]="'non'"
[type]="'tofix'"
[name]="getUid()+'_SepAtt_non'">
</app-form-input>
</fieldset>-->